define('TescoMobile_Reevoo/js/reevoo-tabs',['jquery', 'TescoMobile_Reevoo/js/model/reevoo', 'mage/collapsible', 'mage/tabs', 'domReady!'], function ($, reevoo) {
  'use strict';

  return function () {
    var rbd = rbd || {};
    rbd.clw = {
      init: function () {
        this._productDetailsTabsHook();
        this._moveToReview();
      },
      _productDetailsTabsHook: function () {
        $(".product.data.items").on("dimensionsChanged", function (event, data) {
          var opened = data.opened;
          if (event.target.id === 'tab-label-product_view_reviews' && opened) {
            let perPage = $('#reevoo-reviews-tab #customer-reviews').data('per-page');
            let simpleSku = $('div.product-info-main .sku .value').text().trim();
            reevoo.reevooReviewsTab(simpleSku, perPage);
            return;
          }
          if (event.target.id === 'tab-label-product_view_conversations' && opened) {
            let perPage = $('#reevoo-reviews-conversations-tab #customer-conversation').data('per-page');
            let simpleSku = $('div.product-info-main .sku .value').text().trim();
            reevoo.reevooReviewsConversationsTab(simpleSku, perPage);
            return;
          }
        });
      },
      _moveToReview: function () {
        $('.reevoo-event-trigger-overlay').on('click', function (event) {
          event.preventDefault();
          var tab = $(this).data('reevoo-tab');
          $('.product.data.items .tabs-content > div').each(function (index) {
            if (this.id == tab) {
              $('.product.data.items').tabs('activate', index);
            }
          });
        });
      }
    };
    rbd.clw.init();
  };
});

